import SifAuBaseSerializer from './base';

export default class Connection extends SifAuBaseSerializer {}
